import { render } from "./VendorsList.vue?vue&type=template&id=055c74bb"
import script from "./VendorsList.vue?vue&type=script&lang=js"
export * from "./VendorsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__